import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom'
import { Layout, Menu, Icon } from 'antd';
import appRs from '../../App.reducer'
//import logo from '../../assets/logo.svg'
//import logoFull from '../../assets/logo_full.svg'
import logo from '../../assets/rabbit.png'
import logoFull from '../../assets/b.png'
import { getAdminMenu, getMerchantMenu } from '../../api'
const { Sider } = Layout;
const SubMenu = Menu.SubMenu;

class AppSider extends Component {
    constructor(props) {
        super(props)
        this.state = {
            rootSubMenuKeys: [],
            selectedKeys: [],
            openKeys: [],
            visibleMenuList: [],
            click: false,
            menus: []
        }
    }

    componentDidMount() {
      const { appRs: { userInfo } } = this.props

      if (userInfo.identity.includes('Merchant')) {
        this.getMerchantMenu(sessionStorage.getItem('orgId'))
      } else {
        this.getMenu()
      }
      this.setState({
        selectedKeys: window.location.pathname
      })
    }
    getMenu = async () => {
      let data = await getAdminMenu();
      if(!data) {
        data = [];
      }
      this.setState({ menus : data });
    }
    getMerchantMenu = async (orgId) => {
      let data = await getMerchantMenu(orgId);
      if(!data) {
        data = [];
      }
      this.setState({ menus : data });
    }
    getKeysByLocation = (location) => {
        let pathname = location.pathname
        let selectedKey = ''
        let openKey = ''
        this.rootSubMenuKeys = []
        this.props.appRs.menuList.forEach(menu => {
            if (menu.subList) {
                this.rootSubMenuKeys.push(menu.key)
                menu.subList.forEach(subMenu => {
                    if (pathname.startsWith(subMenu.key)) {
                        selectedKey = subMenu.key
                        openKey = menu.key
                    }
                })
            } else {
                if (pathname.startsWith(menu.key)) {
                    selectedKey = menu.key
                    openKey = ''
                }
            }
        });
        return {
            selectedKeys: [selectedKey],
            openKeys: [openKey]
        }
    }

    onOpenChange = (openKeys) => {
      this.setState({
        click: true
      })
        const latestOpenKey = openKeys.find(key => this.state.openKeys.indexOf(key) === -1);
        if (this.rootSubMenuKeys.indexOf(latestOpenKey) === -1) {
            this.setState({ openKeys});
        } else {
            this.setState({
                openKeys: latestOpenKey ? [latestOpenKey] : [],
            });
        }
    }

    onClick = ({ item, key, keyPath }) => {
        const { location } = this.props
        if(key === '/readme'){
          //window.open('https://www.yuque.com/docs/share/a2eaead9-afc8-445c-8a07-35ea8e1b6e54?#')
          window.open('https://help.yunban.com/?p=23');
        } else {
          this.props.history.push(key + location.search)
          this.setState({
            selectedKeys: [key]
          })
        }
    }

    render() {
        const { location, appRs: { menuList, menuIconList, sider, userInfo } } = this.props
        const hide = location.search.includes("hide=true");
        const qa = window.location.href.includes("localhost") || window.location.href.includes("qa");

        let { selectedKeys, openKeys } = this.state.click?this.state:this.getKeysByLocation(location)
        let { menus } = this.state;
        let menuKeys = [];
        let menuObj = {};

        menus.length > 0 && menus.forEach((item, i) => {
          menuKeys.push(item.modelUrl);
          menuObj[item.modelUrl] = item;
        });
        const menusList = []
        menuKeys.forEach((item, i) => {
          menuList.forEach(dataItem => {
            if(item === dataItem.key.split("/")[1]){
              menusList.push(dataItem);
              return false
            }
          });
        });
        let visibleMenuList = menusList.filter(menu => menu.visible.includes(userInfo.identity)).filter(item => {
            if (userInfo.identity.includes('Merchant')) {
                if (item.key === '/statement' && userInfo.allowBillDownload === false) {
                    return false
                } else if (item.key === '/canteen' && userInfo.allowCanteenManage === false) {
                    return false
                }
                if (item.key === '/canbu' && userInfo.allowCbManage === false) {
                   return false
               }
            }
            return true
        })
        if (!userInfo || userInfo.identity === 'Guest') {
            return null
        }
        return location.pathname !== '/login' && <Sider
            width={sider.width}
            collapsedWidth={sider.collapsedWidth}
            trigger={null}
            collapsible
            collapsed={sider.collapsed}
        >
            <img src={sider.collapsed ? logo : logoFull} alt="" className="logo" />
            <Menu

                theme='dark'
                mode='inline'
                onClick={this.onClick}
                selectedKeys={selectedKeys}
                openKeys={sider.collapsed ? [] : openKeys}
                onOpenChange={this.onOpenChange}
                style={
                    { width: sider.collapsed ? sider.collapsedWidth : sider.width,height: "calc(100% - 64px)",overflow: 'auto' }
                }
            >
                {
                    visibleMenuList.length > 0 && visibleMenuList.map(menu => {
                        let menukey = menu.key.split("/")[1];
                        let modelIcon = menuObj[menukey]["modelIcon"];
                        let modelName = menuObj[menukey]["modelName"];
                        if (menu.subList) {
                            let subListPath = [];
                            if(menuObj[menukey]["child"].length > 0) {
                              menuObj[menukey]["child"].map(item => {
                                subListPath.push(item.modelUrl);
                              })
                            }
                            if(userInfo.hasWallet === false && menu.key === "/wallet") return false;
                            return <SubMenu key={menu.key} title={<span>{modelIcon && <Icon component={menuIconList[modelIcon]} />}<span>{modelName}</span></span>}>
                                {
                                    menu.subList.map(subItem => {
                                      if(subItem.visible.includes(userInfo.identity)) {
                                        if(subItem.manage || (menu.key === "/funds") || (menu.key === "/weak") || (userInfo.allowWalletManage && menu.key === "/wallet") || (userInfo.allowCbManage && menu.key === "/canbu") || userInfo.identity.indexOf('Admin') > -1) {
                                          if(subItem.hide || subListPath.indexOf(subItem.key.substring(1,subItem.key.length)) < 0){
                                            return qa && hide && <Menu.Item key={subItem.key}>
                                              {
                                                subItem.icon && <Icon component={subItem.icon} />
                                              }
                                              <span>{subItem.value}</span>
                                            </Menu.Item>
                                          } else {
                                            return <Menu.Item key={subItem.key}>
                                              {
                                                subItem.icon && <Icon component={subItem.icon} />
                                              }
                                              <span>{subItem.value}</span>
                                            </Menu.Item>
                                          }
                                        } else {
                                          return false;
                                        }
                                      } else {
                                        return false;
                                      }
                                    })
                                }
                            </SubMenu>
                        } else {
                          return <Menu.Item key={menu.key}>
                          {
                            modelIcon && <Icon component={menuIconList[modelIcon]} />
                          }
                          <span>{modelName}</span>
                          </Menu.Item>
                        }
                    })
                }
            </Menu>
        </Sider>
    }
}

export default withRouter(connect(appRs)(AppSider))



// WEBPACK FOOTER //
// ./src/components/AppSider/index.jsx